var map = {
	"./blocks.png": 3690,
	"./books-blue.png": 612,
	"./books.png": 3691,
	"./cancel-blue.png": 613,
	"./cancel.png": 3692,
	"./clock-blue.png": 614,
	"./clock.png": 3693,
	"./confetti.png": 3694,
	"./flag-blue.png": 615,
	"./flag.png": 3695,
	"./gauge-blue.png": 616,
	"./gauge.png": 3696,
	"./gear.png": 3697,
	"./lightbulb-blue.png": 617,
	"./lightbulb.png": 3698,
	"./magnifier-white.png": 3699,
	"./open-book-white.png": 3700,
	"./pencil.png": 3701,
	"./question-and-answer.png": 3702,
	"./rising-blue.png": 618,
	"./rising.png": 3703,
	"./settings-gears-white.png": 3704,
	"./slow.png": 3705,
	"./star.png": 3706,
	"./target.png": 3707,
	"./writing-white.png": 3708
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 371;



//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons ^\.\/.*\.png$
// module id = 371
// module chunks = 0